import { g as getRoomType } from './get-room-type.js';
import { g as getDateFromDatepicker } from './get-date-from-datepicker.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';
import './index3.js';

// REDO OLD ONES

// The format for each month array is: [spanish, english, french, italian, german]. Each language is then composed of [month full name, abbreviature(s)]. If there is an accent in the name or abbreviature,
// it will be present both with and without it.

var eightyJanuary = ['enero', 'ene', 'january', 'jan', 'janvier', 'jan', 'gennaio', 'genn', 'januar', 'jän', 'jan'];
var eightyFebruary = ['febrero', 'feb', 'february', 'feb', 'février', 'fevrier', 'févr', 'fevr', 'febbraio', 'febbr', 'februar', 'feb'];
var eightyMarch = ['marzo', 'mar', 'march', 'mar', 'mars', 'mars', 'marzo', 'mar', 'märz', 'marz', 'märz'];

var eightyApril = ['abril', 'abr', 'april', 'apr', 'avril', 'avr', 'aprile', 'apr', 'april', 'apr'];
var eightyMay = ['mayo', 'may', 'may', 'may', 'mai', 'mai', 'maggio', 'magg', 'mai', 'mai'];
var eightyJune = ['junio', 'jun', 'june', 'jun', 'juni', 'juin', 'giugno', 'giugno', 'juni', 'juni'];

var eightyJuly = ['julio', 'jul', 'july', 'jul', 'juillet', 'juil', 'luglio', 'lug', 'juli', 'juli'];
var eightyAugust = ['agosto', 'ago', 'august', 'aug', 'août', 'aout', 'agosto', 'ago', 'august', 'aug'];
var eightySeptember = ['septiembre', 'sept', 'set', 'september', 'sept', 'set', 'septembre', 'sept', 'settembre', 'set', 'sett', 'september', 'sept'];

var eightyOctober = ['octubre', 'oct', 'october', 'oct', 'octobre', 'oct', 'ottobre', 'ott', 'oktober', 'okt'];
var eightyNovember = ['noviembre', 'nov', 'november', 'nov', 'novembre', 'nov', 'novembre', 'nov', 'november', 'nov'];
var eightyDecember = ['diciembre', 'dic', 'december', 'dec', 'décembre', 'decembre', 'déc', 'dec', 'dicembre', 'dic', 'dezember', 'dez'];

var eightyMonths = [eightyJanuary, eightyFebruary, eightyMarch, eightyApril, eightyMay, eightyJune, eightyJuly, eightyAugust, eightySeptember, eightyOctober, eightyNovember, eightyDecember];

function getMonthNumber(month) {
  month = month.toLowerCase();
  let i;
  for (i = 0; i < 12; i += 1) {
    if (eightyMonths[i].indexOf(month) !== -1) { break; }
  }

  if (i !== 12) { return i + 1; }
  return undefined;
}

/**
 * **BookOnlineNow**
 *
 * @exports bs_52
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  engine._formatChineseDates = function _formatChinaseDates(dateEl) {
    let date = dateEl.replace('月', '').split(' ');
    date = [date[2], `0${date[1]}`.slice(-2), `0${date[0]}`.slice(-2)].join('/');
    return date;
  };

  /**
     * @memberOf module:bs_52
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {
    return new Promise(function (resolve, reject) {

      thn.domReady().then(function () {

        let aux;
        const $ = window.jQuery;
        function normalize(str) {
          if (str === 'br') {
            return 'pt';
          }
          return str;
        }

        aux = $ && $('[id*="_selectedLanguge"] > img[src*="/flags/"]');
        aux = aux && aux.length && aux.attr('src').match(/([a-z]{2})\.[a-z]{3,4}$/);
        aux = aux && aux.length && normalize(aux[1]);
        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        aux = $ && $('#divisions .selected');
        aux = aux && aux.length && aux.attr('class').split(/\s+/).filter(function (cl) { return cl.length === 2; });
        aux = aux && aux.length && normalize(aux[0]);
        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        if (thn.data.propertyId === 1013423) { // Hotel Senorial
          if (window.location.pathname.match(/es-senorial/) || window.location.pathname === '/') {
            resolve('es');
          } else {
            resolve('en');
          }
          return;
        }

        if (thn.data.propertyId === 1013865) { // Lionel (Hotel Linkage)
          if (window.location.pathname.match(/-en\//)) {
            resolve('en');
          } else {
            resolve('tr');
          }
          return;
        }

        if (thn.data.accountUserId === 1043191) {
          const langText = document.querySelector('.langs span')?.textContent || window.location.pathname.match(/^\/(\w{2}\/?)/)[0].replace(/\//g, '');
          if (langText && ctx.langs.test(langText)) {
            resolve(langText);
            return;
          }
        }

        if (thn.data.propertyId !== 1024524) {
          aux = document.querySelector && document.querySelector('a[href*="book-onlinenow.net"][href*="lan_id"]');
          aux = aux && normalize(thn.parseUrlParameter('lan_id', `?${aux.getAttribute('href').split('?')[1]}`).substr(0, 2));
          if (aux && ctx.langs.test(aux)) {
            resolve(aux);
            return;
          }
        }

        // Vicenza, Momento (Hotel Linkage)
        if (!window.jQuery || [1013867, 1013869].includes(thn.data.propertyId)) {
          resolve('en');
          return;
        }

        aux = ctx.getHtmlLang();
        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        aux = $ && $('select:eq(0)');
        aux = aux && aux.length && (aux.val() || '').substr(0, 2);
        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        aux = $ && $('.lang').find('.active').text();
        if (aux) {
          if (aux === 'ENG') {
            resolve('en');
          } else if (aux === 'ESP') {
            resolve('es');
          } else {
            resolve('pt');
          }
          return;
        }
        reject('no_language');
      });
    });
  };

  /**
     * @memberOf module:bs_52
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    // Example: https://zinoviapartments.book-onlinenow.net/index.aspx?Page=3&arrival=23/05/2023&departure=24/05/2023&adults=2&kid2=1
    const url = new URL(ctx.baseUrl);
    const validUrl = url.host.match(/book-onlinenow|otel.direct/);
    const isMobile = thn.data.media.name === 'mobile';

    if (!isMobile && url.pathname.includes('mobile')) {
      url.pathname = url.pathname.replace('/mobile', '');
    }

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    url.searchParams.set('arrival', '[date_begin]');
    url.searchParams.set('departure', '[date_end]');
    url.searchParams.set('adults', '[adults]');
    url.searchParams.set('kid2', '[children]');

    if (ctx.newData.dateBegin && ctx.newData.dateEnd) {
      ctx.newData.dateBegin = ctx.newData.dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      ctx.newData.dateEnd = ctx.newData.dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    }

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_52
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const container = document.body;

    if (container && !thn.bookonlinenowLoaderUpdate) {

      thn.bookonlinenowLoaderUpdate = thn.debounce(function thnBookonlinenowLoaderUpdate() {
        // try to refresh the PW data, then hide only if PW data is not set
        if (!thn.isVisible(document.querySelector('#loading')) && ctx.widget.refresh() && !ctx.widget.isSet()) {
          ctx.widget.hide();
        }
      }, 400);

      thn.observeDom(container, thn.bookonlinenowLoaderUpdate);

      thn.pageUnload(function () {
        thn.stopObserveDom(container, thn.bookonlinenowLoaderUpdate);
        delete thn.bookonlinenowLoaderUpdate;
      });

    }

  };

  /**
    *
    * @memberOf module:bs_52
    *
    */
  const roomDetailsParseData = () => {

    const roomsArray = [...document.querySelectorAll('.RoomCard_wrap__7DM8D, #RateCataloguesDiv')].map((room) => {
      const roomName = room.querySelector('.RoomCard_title__jZWLl, .room-head .box-1 p, .panel-2 .step2-room-txt')?.textContent?.trim();
      const roomType = getRoomType(roomName);
      const roomEl = [...room.querySelectorAll('.RoomCard_roomOptionRow__92kYw, .room-rate, .panel-3 > div > div')].map((rate) => {
        const rateName = rate.querySelector('.RoomCard_roomOptionRow__92kYw strong, .box-2 p.box-title, .step2-rates-txt')?.textContent.trim();
        const ratePrice = thn.parseNumber(rate.querySelector('.RoomCard_roomOptionRow__92kYw :nth-child(4n), .price.neutra, .step2-rates-txt-total')?.textContent);
        const breakfastEl = rate.querySelector('.RoomCard_roomOptionRow__92kYw strong')?.textContent || rateName;
        const hasBreakfast = breakfastEl?.toLowerCase()?.includes('breakfast');
        const isRefundable = !!(rate.querySelector('.green-button[style="display:block"]') || rate.querySelector('.RoomCard_roomOptions__g4c1S > label > u > span')?.textContent === 'Free cancellation');

        const rateData = {
          id: '',
          name: rateName,
          totalNight: ratePrice,
          breakfast: hasBreakfast,
          refundable: isRefundable,
        };

        return rateData;
      });

      const twoAdulst = room.querySelector('.people[style="width:24px"]');
      const threeAdults = room.querySelector('.people[style="width:36px"]');
      let adults;

      if (twoAdulst) {
        adults = 2;
      } else if (threeAdults) {
        adults = 3;
      }

      const roomData = {
        id: '',
        name: roomName,
        adults: thn.parseNumber(room.querySelector('.RoomCard_roomFeatures__uVMrq :nth-child(4n)')?.textContent) || adults || 2,
        children: 0,
        type: roomType,
        prices: roomEl,
      };

      return roomData;
    });

    return roomsArray;
  };

  /**
     * @memberOf module:bs_52
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {
    const language = thn.data.language || 'en';
    const widgetData = {};
    const $ = window.jQuery;

    if (!$) { return widgetData; }

    let $prices,
      prices,
      loading = false;

    if ($('.bookingSummary').length === 0) { // desktop

      loading = $('.loader:visible').length;

      if (!loading || !$('#RatesDiv').children().length) {

        widgetData.dateBegin = getDateFromDatepicker('[id$=_DatePicker_arrival]', { type: 'pickadate' });
        widgetData.dateEnd = getDateFromDatepicker('[id$=_DatePicker_departure]', { type: 'pickadate' });

        const room = thn.parseNumber($('[id$=roomsAndRatesDiv] > p:first-child > strong').text()) || 1;

        widgetData.adults = thn.parseNumber($(`[id$=_selectedAdults${room}]`).val()) || 2;
        widgetData.children = thn.parseNumber($(`[id$=_selectedKids${room}]`).val()) || 0;
        widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);

        $prices = $('.price-wrap .price:visible');

        if ($prices.length === 0
                   && $('[id$=_closeHotelsDiv] > .centered-div').length) {
          widgetData.noRooms = true;
        } else {
          /**
                     * If the saved price exists so we should to mark the rate as special for this property pID : 1024524.
                     */
          const savedPrices = [...document.querySelectorAll('.room-rate')].map((roomEl) => roomEl.querySelector('.save-price'));
          if (thn.data.propertyId === 1024524 && savedPrices.length && savedPrices[0].textContent) {
            widgetData.priceSpecial = 1;
          }
        }
      } else if ($('#dateselector1 [id$="_DD1"]').length > 0) { // another kind of BookOnlineNow. Examples: proID : 1012949

        const dates = [];

        dates.push(`${$('#dateselector1 [id$="_DD1"] option:selected').text()} ${$('#dateselector1 [id$="_MD1"] option:selected').text()}`);
        dates.push(`${$('td[align="left"] [id$="_DD1"] option:selected').text()} ${$('td[align="left"] [id$="_MD1"] option:selected').text()}`);

        dates.forEach(function (date, i) {

          const dateText = date.substring(date.indexOf(',') + 1).trim();
          date = dateText.split(' ');
          let month = getMonthNumber(date[1]);
          month = month.toString().length === 1 ? `0${month}` : month;
          const dateCheck = `${date[2]}/${month}/${date[0]}`;

          if (i === 0) {
            widgetData.dateBegin = dateCheck;
          } else {
            widgetData.dateEnd = dateCheck;
          }
        });

        widgetData.adults = thn.parseNumber($('select[name$="ctl30"] option:selected').text()) || 2;
        const children1 = thn.parseNumber($('select[name$="ctl35"] option:selected').text()) || 0;
        const children2 = thn.parseNumber($('select[name$="ctl38"] option:selected').text()) || 0;
        widgetData.children = children1 + children2;
        widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);

        $prices = $('[id$="lblNights3"]');
        let lowestPrice = false;
        if ($prices.length === 0) {
          widgetData.noRooms = true;

        } else {
          let price;
          $prices.each(function () {
            if ($(this).find('span.TotalPriceDisc').length > 0) {
              const priceDiscount = $(this).html().split('</span>');
              price = thn.parseNumber(priceDiscount[1]);

            } else {
              price = thn.parseNumber($(this).text());
            }

            if (typeof price === 'number') {
              if (lowestPrice === false) {
                lowestPrice = price;
              } else {
                lowestPrice = price < lowestPrice ? price : lowestPrice;
              }
            }
          });
        }

        if (widgetData.dateBegin && widgetData.dateEnd) {
          if (lowestPrice !== false) {
            widgetData.price = (lowestPrice / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)).toFixed(2);
            const currency = $('[id$="currencydd"]').val().split('|');
            widgetData.currency = currency[2];
            widgetData.roomDetails = roomDetailsParseData();
            widgetData.set = true;
          } else {
            widgetData.noRooms = true;
          }
        }
      }

    } else { // mobile

      const dateBegin = `${$('.step2-ar-dep-txt-b:eq(0)').text().trim()} ${$('.step2-ar-dep-txt:eq(1)').text().trim()}`;
      const dateEnd = `${$('.step2-ar-dep-txt-b:eq(1)').text().trim()} ${$('.step2-ar-dep-txt:eq(3)').text().trim()}`;

      if (dateBegin.length && dateEnd.length) {
        widgetData.dateBegin = translateDate(dateBegin, language);
        widgetData.dateEnd = translateDate(dateEnd, language);
      }

      if (!widgetData.dateBegin || !widgetData.dateEnd) {
        widgetData.dateBegin = translateDate(dateBegin, 'en');
        widgetData.dateEnd = translateDate(dateEnd, 'en');
      }

      if (thn.data.language === 'zh') {
        widgetData.dateBegin = engine._formatChineseDates(dateBegin);
        widgetData.dateEnd = engine._formatChineseDates(dateEnd);
      }

      const persons = $('.step2-roompersons:visible > span:first-child').clone().children().remove()
        .end()
        .text()
        .match(/\D+(\d+)\D*(\d+)?/);
      widgetData.adults = persons && persons[1] ? (parseInt(persons[1], 10) || 1) : 1;
      widgetData.children = persons && persons[2] ? (parseInt(persons[2], 10) || 0) : 0;
      widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);

      $prices = $('.step2-rates-txt-total').clone().children().remove()
        .end();

      if ($prices.length === 0
                && $('[id*="noAvailability"]:visible').length) {
        widgetData.noRooms = true;
      }
    }

    if (!loading) {

      prices = Array.from($prices.map(function (idx, el) {
        return thn.parseNumber($(el).text());
      })).filter(function (prc) {
        return prc;
      });

      if (widgetData.dateBegin && widgetData.dateEnd) {
        if (prices.length) {
          widgetData.price = thn.parseNumber((Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)));
          widgetData.currency = thn.parseCurrency($prices.eq(0).text().trim().match(/[^\d\s.,]+/)[0]);
          if (!widgetData.currency) {
            const $cur1 = $('select[name$="$currencydd"]');
            const currencyText = document.querySelector('[id*="_selectedCurrency"]')?.textContent;
            const cur2 = thn.data.media.name === 'mobile' ? (thn.parseUrlParameter('cur') || currencyText) : currencyText?.match(/\((.*?)\)/)[1];
            widgetData.currency = ($cur1 && $cur1.length && $cur1.val().split('|')[2])
                            || thn.parseCurrency(cur2);
          }
          widgetData.roomDetails = roomDetailsParseData();
          widgetData.set = true;

        } else if (document.querySelector('[id*=closeHotelsDiv] .centered-div')) {
          widgetData.noRooms = true;
        }
      }
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_52
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {
    const language = thn.data.language || 'en';
    const widgetData = {};
    const $ = window.jQuery;
    const purchaseObj = thn.dataLayerHelper.get('ecommerce');
    const bookingId = thn.objectGet(purchaseObj, 'transaction_id');

    if (bookingId) {
      widgetData.bookingId = bookingId;
      widgetData.dateBegin = thn.objectGet(purchaseObj, 'checkIn').replace(/-/g, '/');
      widgetData.dateEnd = thn.objectGet(purchaseObj, 'checkOut').replace(/-/g, '/');
      widgetData.price = thn.parseNumber(thn.objectGet(purchaseObj, 'value'));
      widgetData.currency = thn.objectGet(purchaseObj, 'currency');
      widgetData.set = true;
      return widgetData;
    }

    if (!$) { return widgetData; }

    let price,
      dates;

    // Expired session page is a "false" Booking Confirmed page
    if ($('.modal-body:contains(session has expired)').length) {
      widgetData.set = false;
      return widgetData;
    }

    const months = {
      يناير: 'January',
      فبراير: 'February',
      مارس: 'March',
      أبريل: 'April',
      مايو: 'May',
      يونيو: 'June',
      يوليو: 'July',
      أغسطس: 'August',
      سبتمبر: 'September',
      أكتوبر: 'October',
      نوفمبر: 'November',
      ديسمبر: 'December',
    };

    const $dateBegin = `${$('.step2-ar-dep-txt-b:eq(0)').text().trim()} ${$('.step2-ar-dep-txt:eq(1)').text().trim()}`;
    const $dateEnd = `${$('.step2-ar-dep-txt-b:eq(1)').text().trim()} ${$('.step2-ar-dep-txt:eq(3)').text().trim()}`;
    const $priceEl = $('.step3-total-right:visible');

    if ($dateBegin && $dateEnd && $priceEl.length) {

      if (thn.data.language === 'ar') { // When the language selected is arab, `thn.translate_date` can't read months
        const monthBegin = $dateBegin.slice(3, $dateBegin.length - 5);
        const monthEnd = $dateEnd.slice(3, $dateEnd.length - 5);
        const dateBegin = $dateBegin.replace(monthBegin, months[monthBegin]);
        const dateEnd = $dateEnd.replace(monthEnd, months[monthEnd]);
        widgetData.dateBegin = translateDate(dateBegin, 'en');
        widgetData.dateEnd = translateDate(dateEnd, 'en');
      } else {
        widgetData.dateBegin = translateDate($dateBegin, language);
        widgetData.dateEnd = translateDate($dateEnd, language);
      }
      price = $priceEl.text();

    } else {

      dates = $($($('tr.requests')[1]).find('td')[1]).text();
      if (dates) {
        dates = dates.split('-');

        widgetData.dateBegin = translateDate(dates[0], language);
        widgetData.dateEnd = translateDate(dates[1], language);
      }

      price = $('.request').contents().get(0)?.nodeValue;
    }

    if (price) {
      widgetData.price = thn.parseNumber(price);
      widgetData.currency = thn.parseCurrency(price.match(/([^\d\s,.]+)\s*\d+/)[1]);
    }

    const $res = $('a[href*=resnr]');
    if ($res && $res.length) {
      widgetData.bookingId = thn.parseUrlParameter('resnr', $('a[href*=resnr]').attr('href'));
    }

    return widgetData;
  };

  return engine;

}

export { factory };
